import { render, staticRenderFns } from "./move-product.vue?vue&type=template&id=d59bbdae&scoped=true"
import script from "./move-product.vue?vue&type=script&lang=js"
export * from "./move-product.vue?vue&type=script&lang=js"
import style0 from "./move-product.vue?vue&type=style&index=0&id=d59bbdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59bbdae",
  null
  
)

export default component.exports